import React from 'react';
import {Card, CardHeader} from 'material-ui/Card';
import {connect} from 'react-redux';
import { sortedOptions, sortedQuestions, sortedCategories } from '../reducer';
import RecentlyUpdatedItemsList from '../components/RecentlyUpdatedItemsList';
import { fetchNextResponsesPage, previousResponsesPage } from '../actions/responses';
import RecentResponseList from '../components/RecentResponseList';
import { withRouter } from 'react-router'
import SearchResponseList from '../components/SearchResponseList';
import { deleteResponse } from '../actions/responses';
import { makeTitle } from '../reducer';


export const adminCardStyle = {
  maxWidth: 1024,
  margin: "0px auto",
  marginBottom: "20px"
}

class AdminHomepage extends React.Component {

  constructor(props) {
    super(props);
    this.onTouchResponse = this.onTouchResponse.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  componentDidMount() {
    if (!this.props.responses.length) {
      this.props.fetchResponses();
    }
  }

  onTouchResponse(response) {
    this.props.router.push(`/questionnaire/results/${response.metadata.id}/monitoring`)
  }

  onDeleteClick(response, e) {
    e.stopPropagation();
    if(global.confirm("Are you sure you want to permanently delete this fishery? You cannot undo this action. Fishery: " + makeTitle(response))){
      this.props.handleDeleteResponse(response.metadata.id, response.metadata.createdAt)
    }
  }

  render() {

    let {responses, fetchingResponses, min, max, hasNext, onNext, onPrevious, userEmail} = this.props;

    return  (
      <div>
        <Card style={adminCardStyle}>
          <CardHeader title="Search Responses" />
          <SearchResponseList onClick={this.onTouchResponse} limit={5} userEmail={userEmail} onDeleteClick={this.onDeleteClick} />
        </Card>

        <Card style={adminCardStyle}>
          <CardHeader title="Recent Responses" />
          <RecentResponseList
            responses={responses}
            numItems={12}
            onClick={this.onTouchResponse}
            fetching={fetchingResponses}
            min={min}
            max={max}
            hasNext={hasNext}
            onNext={onNext}
            onPrevious={onPrevious}
            userEmail={userEmail}
            onDeleteClick={this.onDeleteClick}
          />
        </Card>

        <Card style={adminCardStyle}>
          <CardHeader title="Questions" />
          <RecentlyUpdatedItemsList numItems={7} items={this.props.questions}
            rootUrl="/admin/questions" />
        </Card>
        <Card style={adminCardStyle}>
          <CardHeader title="Options" />
          <RecentlyUpdatedItemsList numItems={7} items={this.props.options}
            rootUrl="/admin/options/monitoring" editUrl="/admin/options/edit" />
        </Card>
      </div>
    );
  }

}

let mapStateToProps = (state) => {
  const { currentCursor, pages } = state.responses.allResponses;
  const page = pages[currentCursor];
  const userEmail = state.auth.email ? state.auth.email : "";
  return {
    options: sortedOptions(state),
    questions: sortedQuestions(state),
    categories: sortedCategories(state),
    responses: page ? page.items : [],
    fetchingResponses: state.responses.allResponses.fetching,
    min: page ? page.min : 0,
    max: page ? page.max : 0,
    hasNext: page ? !!page.nextCursor : true,
    userEmail: userEmail
  }
}

let mapDispatchToProps = (dispatch, state) => {
  return {
    fetchResponses: () => dispatch(fetchNextResponsesPage(state)),
    onNext: () => dispatch(fetchNextResponsesPage(state)),
    onPrevious: () => dispatch(previousResponsesPage()),
    handleDeleteResponse: (responseID, createdAt) => dispatch(deleteResponse(responseID, createdAt))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AdminHomepage));
